import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import { MembershipInfoResponse } from './useMembershipInfo.interface';
import fetchMembershipInfo from './useMembershipInfo.request';

const useMembershipInfo = (options?: Omit<UseQueryOptions<MembershipInfoResponse>, 'queryKey'>) => {
    return useQuery<MembershipInfoResponse>({
        queryKey: ['membershipInfo'],
        queryFn: fetchMembershipInfo,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: (failureCount, error) => {
            // Don't retry on 4xx — these are deterministic (e.g. "no Member for this user")
            // and retrying just multiplies backend hits and Datadog RUM events.
            if (isAxiosError(error) && error.response?.status && error.response.status < 500) {
                return false;
            }
            return failureCount < 3;
        },
        ...options,
    });
};

export default useMembershipInfo;
